import type { ParticipantType } from '@entities/participants';

import type {
  HoldToggleRequest,
  HoldToggleUsecase,
} from '@usecases/hold-toggle.usecase';
import { InvalidHoldToggleRequest } from '@usecases/hold-toggle.usecase';

import type { BaseController } from '@infra/controllers/base.controller';

export type HoldToggleInput = {
  onHold: boolean;
  participantType: ParticipantType;
};

export type HoldToggleOutput = InvalidHoldToggleRequest | void;

export class HoldToggleController
  implements BaseController<HoldToggleInput, HoldToggleOutput>
{
  constructor(private usecase: HoldToggleUsecase) {}

  async handle(input: HoldToggleInput): Promise<HoldToggleOutput> {
    const request: HoldToggleRequest = {
      putOnHold: input.onHold,
      participantType: input.participantType,
    };

    try {
      await this.usecase.run(request);
    } catch (error) {
      if (error instanceof InvalidHoldToggleRequest) {
        return error;
      }

      throw error;
    }
  }
}
